// Analytics API

import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { ANALYTICS } = API_ENDPOINTS;

export const analyticsApi = {
  /** GET /admin/dashboard/ — overview + sales/loss value summary + recent sales */
  getDashboard: () => axiosInstance.get(ANALYTICS.DASHBOARD),

  /** GET /admin/sales-analytics/?period=today|week|month|year */
  getSalesAnalytics: (period = 'today') =>
    axiosInstance.get(ANALYTICS.SALES, { params: { period } }),

  /** GET /admin/sales/by-source/?period= — CAP vs OSM buckets for the period */
  getSalesBySource: (period = 'today') =>
    axiosInstance.get(ANALYTICS.BY_SOURCE, { params: { period } }),

  /** GET /admin/sales-analytics/inquiries/ — the inquiries behind a funnel number */
  getFunnelInquiries: ({ period = 'month', stage, status, q = '', page = 1, pageSize = 25 }) =>
    axiosInstance.get(ANALYTICS.FUNNEL_LIST, {
      params: {
        period,
        stage: stage || undefined,
        status: status || undefined,
        q: q || undefined,
        page,
        page_size: pageSize,
      },
    }),

  /** GET /admin/sales/by-source/list/ — paginated + searchable drill-down for a date range */
  getSalesBySourceList: ({ source, from, to, q = '', page = 1, pageSize = 25 }) =>
    axiosInstance.get(ANALYTICS.BY_SOURCE_LIST, {
      params: { source, from, to, q: q || undefined, page, page_size: pageSize },
    }),
};
